import dataUriToBlob from './dataUriToBlob';

export default async function uploadToStorage(signature, dataUri) {
  const file = dataUriToBlob(dataUri);
  const { url, refUrl, fields } = signature;

  await fetch(url, {
    method: 'PUT',
    mode: 'cors',
    headers: {
      ...fields,
      Accept: `${fields['Content-Type']}`,
    },
    body: file,
  });

  return refUrl;
}
